module.exports = __webpack_public_path__ + "static/media/section12-justask.96554ddd.png";